import React from "react";

type SuperlinkMarketSearchDidYouKnowProps = {};

const containerStyle: React.CSSProperties = {
  cursor: 'default',
  fontFamily: "GT Planar Regular",
  paddingTop: "20px",
  paddingBottom: "25px",
  paddingLeft: "24px",
  paddingRight: "24px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignContent: "center",
  alignItems: "center",
  textAlign: 'center',
  justifyItems: 'center',
  backgroundColor: "rgba(241, 241, 243, 1)",
  gap: 8,
};

export const formatCurrency = (
  price: number,
  currency: string,
  region: string
): string => {
  return new Intl.NumberFormat(`en-${region}`, {
    style: "currency",
    currency: currency,
  }).format(price);
};

const SuperlinkMarketSearchDidYouKnow: React.FC<
  SuperlinkMarketSearchDidYouKnowProps
> = () => {
  return (
    <div style={containerStyle}>
      <p style={{
        color: 'rgba(0, 0, 0, 1)',
        fontSize: '16px',
        margin: 0
      }}>💡 Did you know?</p>
      <p style={{
        color: 'rgba(0, 0, 0, 0.6)',
        fontSize: '14px',
        margin: 0
      }}>Traditional domains can be payment addresses, websites, and email</p>
    </div>
  );
};

export default SuperlinkMarketSearchDidYouKnow;
